// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JAZ3","title":"Header_title__3srCH","side":"Header_side__24ylc"};